import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import AuthForm from './components/AuthForm';
import Image from '../../components/AppImage';

const DEMO_VENDOR_EMAILS = [
  'melondropp95@gmail.com',
  'michael@abgmultifamily.com',
  'michael@atlasprocurementsolution.us',
  'mcrocefoglia95@gmail.com',
];

const LoginSignUp = () => {
  const { isAuthenticated, loading, user, userProfile } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (!loading && isAuthenticated && user) {
      const isVendor =
        userProfile?.role === 'vendor' ||
        DEMO_VENDOR_EMAILS?.includes(user?.email?.toLowerCase());

      if (isVendor) {
        navigate('/vendor-hub-dashboard', { replace: true });
      } else {
        navigate('/all-projects', { replace: true });
      }
    }
  }, [isAuthenticated, loading, navigate, user, userProfile]);

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center" style={{ background: 'linear-gradient(135deg, #F58A54 0%, #F06F6B 50%, #E0528A 100%)' }}>
        <div className="flex flex-col items-center gap-4">
          <svg className="w-10 h-10 animate-spin text-white" fill="none" viewBox="0 0 24 24">
            <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" />
            <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z" />
          </svg>
          <p className="text-white/80 text-sm">Loading...</p>
        </div>
      </div>
    );
  }

  return (
    <div
      className="min-h-screen flex flex-col items-center justify-center px-4 py-12 relative overflow-hidden"
      style={{ background: 'linear-gradient(135deg, #F58A54 0%, #F06F6B 50%, #E0528A 100%)' }}
    >
      {/* Background decorative elements */}
      <div className="absolute inset-0 overflow-hidden pointer-events-none">
        <div className="absolute -top-32 -right-32 w-96 h-96 rounded-full bg-white/5 blur-3xl" />
        <div className="absolute -bottom-32 -left-32 w-96 h-96 rounded-full bg-white/5 blur-3xl" />
        <div className="absolute top-1/4 left-1/4 w-64 h-64 rounded-full bg-white/3 blur-2xl" />
      </div>

      {/* Logo */}
      <div className="relative mb-8 flex flex-col items-center">
        <div className="h-60 flex items-center mb-3">
          <Image
            src="/assets/images/Stackd_logo_design_no_background_white_text-1772559212336.png"
            alt="Stackd"
            className="h-60 w-auto object-contain"
          />
        </div>
        <p className="text-white/80 text-sm text-center max-w-xs">
          Your smart purchase comparison platform
        </p>
      </div>

      {/* Auth Card */}
      <div className="relative w-full max-w-md">
        <AuthForm />
      </div>
    </div>
  );
};

export default LoginSignUp;
